import { render } from "./ModalListadoSucursales.vue?vue&type=template&id=4a98237b"
import script from "./ModalListadoSucursales.vue?vue&type=script&lang=js"
export * from "./ModalListadoSucursales.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__